"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toyota = exports.Lexus = void 0;
var _styledComponents = require("styled-components");
var _LexusTypography = require("../../../components/LexusTypography");
var _ToyotaTypography = require("../../../components/ToyotaTypography");
var _index = _interopRequireDefault(require("../../PriceFormat/index.styled"));
var _breakpoints = _interopRequireDefault(require("../../breakpoints"));
var Styled = _interopRequireWildcard(require("./index.styled"));
const Lexus = exports.Lexus = (0, _styledComponents.css)`
  ${Styled.Tile} {
    box-shadow: 0 0 6px 0 rgba(75, 75, 75, 0.5);
    padding: 25px 16px;
    &:hover {
      box-shadow: 0 0 6px 0 rgba(75, 75, 75, 0.5);
    }
    ${(0, _breakpoints.default)("tablet", "up")} {
      padding: 35px 25px;
    }
  }

  ${Styled.Jelly} {
    padding: 15px 15px 0 15px;
    margin: 0 0 5px;
    ${(0, _breakpoints.default)("mobile")} {
      padding: 15px 0 0 0;
      margin: 0 0 10px;
    }
    ${(0, _breakpoints.default)("tablet", "up")} {
      margin: 0 0 35px;
    }
  }

  ${Styled.JellyLabelError} {
    ${(0, _LexusTypography.nobel)({
  weight: "bold",
  sizing: "body12",
  spacing: "1.2px"
})}
  }

  ${Styled.AsShown} {
    display: none;
  }

  ${Styled.Name} {
    margin: 0 0 10px;
    align-items: center;
    ${(0, _LexusTypography.nobel)({
  weight: "regular",
  sizing: "heading24",
  spacing: "wide"
})}
    ${(0, _breakpoints.default)("mobile")} {
      ${(0, _LexusTypography.nobel)({
  weight: "regular",
  sizing: "subheading14",
  spacing: "wide"
})}
    }
  }

  ${Styled.SpecValue} {
    ${(0, _LexusTypography.pakt)({
  weight: "regular",
  sizing: "heading30",
  spacing: "narrow"
})}
    ${_index.default.Symbol} {
      ${(0, _LexusTypography.pakt)({
  weight: "normal",
  sizing: "subheading16",
  spacing: "narrow"
})}
    }
    ${(0, _breakpoints.default)("mobile")} {
      ${(0, _LexusTypography.pakt)({
  weight: "regular",
  sizing: "heading24",
  spacing: "narrow"
})}
    }
  }

  ${Styled.SpecName} {
    color: #000;
    ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "link10",
  spacing: "narrow"
})}
    ${(0, _breakpoints.default)("mobile")} {
      ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "legal8",
  spacing: "narrow"
})}
    }
  }

  ${Styled.SpecsError} {
    ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "body12",
  spacing: "0.48px"
})}
    line-height: 40px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "subheading16",
  spacing: "0.64px"
})}
      line-height: 40px;
    }
  }

  ${Styled.JellyDisclaimer} {
    display: block;
    ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "link10",
  spacing: "narrow"
})}
    ${(0, _breakpoints.default)("mobile")} {
      ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "legal8",
  spacing: "narrow"
})}
    }
  }

  ${Styled.JellyDisclaimerError} {
    ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "body12",
  spacing: "0.28px"
})}
    font-size: 7px;
    line-height: 10px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "legal9",
  spacing: "0.36px"
})}
      line-height: 12px;
    }
  }
  ${Styled.TopLabel} {
    display : none;
  }
`;
const Toyota = exports.Toyota = (0, _styledComponents.css)`
  ${Styled.Tile} {
    border: 1px solid #efefef;
    padding: 24px 16px;
    &:hover {
      box-shadow: 0 4px 16px 0 rgb(0 0 0 / 8%);
    }
    ${(0, _breakpoints.default)("tablet", "up")} {
      padding: 56px 56px 40px;
    }
    ${(0, _breakpoints.default)("desktop", "up")} {
      padding: 56px 56px 48px;
    }
  }

  ${Styled.Jelly} {
    padding: 0px;
    margin: 0 0 5px;
  }

  ${Styled.JellyLabelError} {
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "bold",
  sizing: "label01",
  spacing: "1.2px"
})}
  }


  ${Styled.AsShown} {
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin: 0 0 16px;
    color: #767676;
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "regular",
  sizing: "label10",
  spacing: "0"
})}
    ${(0, _breakpoints.default)("tablet", "up")} {
      margin: 0 0 16px;
      align-items: center;
    }
  }

  ${Styled.Name} {
    margin: 0 0 8px;
    align-items: flex-start;
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "heading03",
  spacing: "0"
})}
    ${(0, _breakpoints.default)("mobile")} {
      ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "heading05",
  spacing: "0"
})}
    }
    ${(0, _breakpoints.default)("tablet", "up")} {
      margin: 0 0 35px;
      align-items: center;
    }
  }

  ${Styled.SpecValue} {
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "heading03",
  spacing: "-0.5px"
})}
    ${(0, _breakpoints.default)("mobile")} {
      ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "heading05",
  spacing: "-0.5px"
})}
    }
  }

  ${Styled.SpecName} {
    color: #58595b;
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "label10",
  spacing: "0"
})}
    ${(0, _breakpoints.default)("tablet")} {
      max-width: 90px;
    }
  }


  ${Styled.SpecsError} {
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "label01"
})}
    line-height: 30px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "body01"
})}
      line-height: 30px;
    }
  }

  ${Styled.JellyDisclaimer} {
    display: none;
  }


  ${Styled.JellyDisclaimerError} {
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "label01",
  spacing: "0.28px"
})}
    font-size: 7px;
    line-height: 10px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "label01",
  spacing: "0.36px"
})}
      font-size: 9px;
      line-height: 12px;
    }
  }

  ${Styled.TopLabel} {
    padding: 4px 8px;
    border-radius: 4px;
    background-color: #000000;
    color: #ffffff;
    position: absolute;
    top: 4px;
    left: 4px;
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "button02"
})}
    ${(0, _breakpoints.default)("mobile")} {
      ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "label10"
})}
    }
  }
`;